import { Grid } from '@mui/material'
import TaskChecklistTable from 'components/Tasks/TaskChecklistTable'
type Item = { id: string; label: string; done?: boolean }
type AutoChecklistProps = {
  items?: Item[]
  editing?: boolean
  onToggle?: (item: Item) => void
}

const AutoChecklist = ({ items, editing, onToggle }) => {
  return (
    <Grid item xs={12} md={12} sx={{ display: 'flex', flexDirection: 'column', p: 1, width: '100%' }}>
      <TaskChecklistTable items={items} editing={editing} onToggle={onToggle} dense height="100%" />
    </Grid>
  )
}
export default AutoChecklist
